module.exports = __webpack_public_path__ + "static/img/main__test__img.a55c7d77.svg";